/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import { types } from 'mobx-state-tree';
import { isAlive } from 'mobx-state-tree';

const ACTIVE_PLACEHOLDER_EXISTS_DEFAULT = false;

export default types
	.model('SlotPlaceholderStateModel', {
		activePlaceholderExists: types.optional(types.boolean, ACTIVE_PLACEHOLDER_EXISTS_DEFAULT)
	})
	.views((self) => ({
		/**
		 * @return {boolean} activePlaceholderExists
		 */
		getActivePlaceholderExists() {
			if (isAlive(self)) {
				return self.activePlaceholderExists;
			} else {
				return ACTIVE_PLACEHOLDER_EXISTS_DEFAULT;
			}
		}
	}))
	.actions((self) => {
		return {
			setActivePlaceholderExists(activePlaceholderExists) {
				self.activePlaceholderExists = activePlaceholderExists;
			}
		};
	});



// WEBPACK FOOTER //
// ./src/js/models/SlotPlaceholderStateModel.js